/* eslint-disable @typescript-eslint/no-explicit-any */

export default (store: any) => (next: any) => (action: any) => {
   
  if (action.type === 'APP_STATE_CHANGED') {
    return next(action);
  }

  return next(action);
};
